import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { VocePicker } from "@/components/prima_nota/VocePicker";

const fmt = n => Number(n || 0).toLocaleString("it-IT", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export default function PrimaNotaVerificaPage() {
  const navigate = useNavigate();
  const [report, setReport] = useState(null);
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState(null);
  const [pickerFor, setPickerFor] = useState(null); // {da_conto}
  const [showFoglieNonUsate, setShowFoglieNonUsate] = useState(false);
  const [showOrfaniRows, setShowOrfaniRows] = useState(false);
  const [showNullRows, setShowNullRows] = useState(true);

  const apriFattura = (id_fattura) => {
    if (!id_fattura) return;
    navigate(`/g/prima_nota/prima_nota_fatture?open=${id_fattura}`);
  };

  const carica = async () => {
    setLoading(true); setErr(null);
    try {
      const r = await api.get("/pn/verifica/integrita");
      setReport(r.data);
    } catch (e) { setErr(e.response?.data?.detail || "Errore"); }
    finally { setLoading(false); }
  };
  useEffect(() => { carica(); }, []);

  const riassegna = async (daConto, aConto) => {
    if (!window.confirm(`Riassegnare tutte le righe con conto ${daConto} al conto ${aConto}?`)) return;
    try {
      const r = await api.post("/pn/verifica/riassegna-conto", null, { params: { da_conto: daConto, a_conto: aConto } });
      alert(`✓ Modificate ${r.data.righe_modificate} righe`);
      setPickerFor(null);
      await carica();
    } catch (e) { alert(e.response?.data?.detail || "Errore"); }
  };

  if (loading && !report) return <div style={{ padding: 30, textAlign: "center", color: "#888" }}>Caricamento...</div>;

  const t = report?.totali;
  const orfani = report?.orfani || [];
  const orfaniRows = report?.orfani_rows || [];
  const nullInv = report?.null_o_invalid || { righe: 0, tot: 0, fatture: [], rows: [] };
  const nullRows = nullInv.rows || [];
  const foglieNon = report?.foglie_non_usate || [];

  return (
    <div>
      <div className="sw-page-title">
        <h1>🔍 Verifica Integrità Piano dei Conti</h1>
        <button onClick={carica} disabled={loading} data-testid="pn-ver-reload"
          style={{ padding: "6px 14px", background: "#00695c", color: "white", border: "none", fontSize: 12, fontWeight: 700, cursor: "pointer" }}>
          {loading ? "..." : "↻ Verifica ora"}
        </button>
      </div>

      {err && <div style={{ margin: "0 20px", padding: 10, background: "#fff0f0", color: "#c00", fontSize: 12, fontWeight: 700 }}>{err}</div>}

      {report && (
        <>
          <div style={{ margin: "8px 20px", padding: 14, background: report.ok ? "#e8f5e9" : "#fff3e0", border: `2px solid ${report.ok ? "#1b5e20" : "#ef6c00"}`, color: report.ok ? "#1b5e20" : "#bf360c" }}>
            <div style={{ fontSize: 16, fontWeight: 800, marginBottom: 6 }}>
              {report.ok ? "✓ TUTTI I CONTI SONO COLLEGATI" : "⚠ CI SONO RIGHE CON CONTO NON VALIDO"}
            </div>
            <div style={{ fontSize: 12 }}>
              <b>{t.righe_totali.toLocaleString("it-IT")}</b> righe contabili totali ·
              <span style={{ color: "#1b5e20", marginLeft: 6 }}><b>{t.righe_ok.toLocaleString("it-IT")}</b> ok</span> ·
              {t.righe_orfane > 0 && <span style={{ color: "#c62828", marginLeft: 6 }}><b>{t.righe_orfane}</b> orfane</span>}
              <br />
              <b>{t.conti_in_piano}</b> conti nel piano · <b>{t.conti_usati_in_righe}</b> conti usati nelle righe · <b>{foglieNon.length}</b> foglie non utilizzate
            </div>
          </div>

          {/* CONTI ORFANI */}
          {orfani.length > 0 && (
            <div style={{ margin: "0 20px 12px", border: "2px solid #c62828", background: "white" }}>
              <div style={{ padding: "6px 12px", background: "#c62828", color: "white", fontWeight: 800, fontSize: 13 }}>
                ⚠ Conti presenti nelle righe ma NON nel piano dei conti ({orfani.length})
              </div>
              <table className="sw-table sw-table-compact" style={{ fontSize: 12, width: "100%" }}>
                <thead style={{ background: "#37474f", color: "white" }}>
                  <tr>
                    <th style={{ width: 80 }}>CONTO</th>
                    <th style={{ width: 100, textAlign: "right" }}>RIGHE</th>
                    <th style={{ width: 130, textAlign: "right" }}>TOT IMPORTO</th>
                    <th style={{ width: 90, textAlign: "right" }}>FATTURE</th>
                    <th>ID OPERAZIONI (prime 10)</th>
                    <th style={{ width: 200, textAlign: "center" }}>AZIONI</th>
                  </tr>
                </thead>
                <tbody>
                  {orfani.map(o => (
                    <tr key={o.conto} data-testid={`pn-ver-orf-${o.conto}`}>
                      <td style={{ fontFamily: "monospace", fontWeight: 700, color: "#c62828" }}>[{o.conto}]</td>
                      <td style={{ textAlign: "right", fontFamily: "monospace", fontWeight: 700 }}>{o.righe}</td>
                      <td style={{ textAlign: "right", fontFamily: "monospace", fontWeight: 700 }}>€ {fmt(o.tot_importo)}</td>
                      <td style={{ textAlign: "right", fontFamily: "monospace" }}>{o.fatture_distinte}</td>
                      <td style={{ fontSize: 10, fontFamily: "monospace", color: "#555" }}>
                        {o.id_fatture.map((f, idx) => (
                          <span key={`${o.conto}-${f}-${idx}`}>
                            <button onClick={() => apriFattura(f)}
                              data-testid={`pn-ver-orf-open-${f}`}
                              style={{ padding: "1px 6px", margin: "0 2px", background: "white", color: "#1565c0", border: "1px solid #1565c0", fontSize: 10, fontFamily: "monospace", fontWeight: 700, cursor: "pointer" }}>
                              {f} ↗
                            </button>
                          </span>
                        ))}
                        {o.fatture_distinte > 10 ? " …" : ""}
                      </td>
                      <td style={{ textAlign: "center" }}>
                        <button onClick={() => setPickerFor(o.conto)} data-testid={`pn-ver-riass-${o.conto}`}
                          style={{ padding: "4px 10px", background: "#1565c0", color: "white", border: "none", fontSize: 11, fontWeight: 700, cursor: "pointer" }}>
                          🔄 Riassegna a conto valido
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* Dettaglio singole righe orfane (collassabile) */}
              {orfaniRows.length > 0 && (
                <div style={{ borderTop: "1px solid #ddd" }}>
                  <div onClick={() => setShowOrfaniRows(s => !s)}
                    style={{ padding: "6px 12px", background: "#fff3e0", color: "#bf360c", fontWeight: 700, fontSize: 12, cursor: "pointer", display: "flex", alignItems: "center", gap: 8 }}>
                    <span>{showOrfaniRows ? "▼" : "▶"}</span>
                    <span>📌 Dettaglio singole righe orfane ({orfaniRows.length}{orfaniRows.length >= 200 ? "+" : ""})</span>
                  </div>
                  {showOrfaniRows && (
                    <table className="sw-table sw-table-compact" style={{ fontSize: 11, width: "100%" }}>
                      <thead style={{ background: "#37474f", color: "white" }}>
                        <tr>
                          <th style={{ width: 100 }}>ID FATTURA</th>
                          <th style={{ width: 80 }}>CONTO</th>
                          <th style={{ width: 130, textAlign: "right" }}>IMPORTO</th>
                          <th style={{ width: 110 }}>DATA REG.</th>
                          <th style={{ width: 80 }}>PLESSO</th>
                          <th>RIGA ID</th>
                          <th style={{ width: 140, textAlign: "center" }}>AZIONE</th>
                        </tr>
                      </thead>
                      <tbody>
                        {orfaniRows.map(rw => (
                          <tr key={rw.riga_id} data-testid={`pn-ver-orfrow-${rw.riga_id}`}>
                            <td style={{ fontFamily: "monospace", fontWeight: 700, color: "#1565c0" }}>{rw.id_fattura ?? "—"}</td>
                            <td style={{ fontFamily: "monospace", fontWeight: 700, color: "#c62828" }}>[{rw.conto}]</td>
                            <td style={{ textAlign: "right", fontFamily: "monospace", fontWeight: 700 }}>€ {fmt(rw.importo)}</td>
                            <td style={{ fontFamily: "monospace", color: "#555" }}>{rw.data_registrazione || "—"}</td>
                            <td style={{ fontFamily: "monospace", color: "#555" }}>{rw.plesso || "—"}</td>
                            <td style={{ fontFamily: "monospace", fontSize: 9, color: "#888" }}>{rw.riga_id}</td>
                            <td style={{ textAlign: "center" }}>
                              {rw.id_fattura ? (
                                <button onClick={() => apriFattura(rw.id_fattura)}
                                  data-testid={`pn-ver-open-orf-${rw.id_fattura}`}
                                  style={{ padding: "3px 10px", background: "#1565c0", color: "white", border: "none", fontSize: 11, fontWeight: 700, cursor: "pointer" }}>
                                  📂 Apri fattura
                                </button>
                              ) : <span style={{ color: "#999", fontSize: 10 }}>Senza fattura</span>}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  )}
                </div>
              )}
            </div>
          )}

          {/* RIGHE NULL */}
          {nullInv.righe > 0 && (
            <div style={{ margin: "0 20px 12px", border: "2px solid #ef6c00", background: "white" }}>
              <div style={{ padding: "6px 12px", background: "#ef6c00", color: "white", fontWeight: 800, fontSize: 13 }}>
                ⚠ Righe con conto NULL/0/non numerico ({nullInv.righe})
              </div>
              <div style={{ padding: 12, fontSize: 12, background: "#fff8e1" }}>
                <b>{nullInv.righe}</b> righe per un totale di <b>€ {fmt(nullInv.tot)}</b>.
                {" "}Clicca <b>📂 Apri fattura</b> per correggere manualmente la riga contabile.
              </div>
              <div onClick={() => setShowNullRows(s => !s)}
                style={{ padding: "6px 12px", background: "#ffe0b2", color: "#bf360c", fontWeight: 700, fontSize: 12, cursor: "pointer", display: "flex", alignItems: "center", gap: 8, borderTop: "1px solid #ffcc80" }}>
                <span>{showNullRows ? "▼" : "▶"}</span>
                <span>📌 Dettaglio singole righe ({nullRows.length}{nullRows.length >= 200 ? "+" : ""})</span>
              </div>
              {showNullRows && (
                <table className="sw-table sw-table-compact" style={{ fontSize: 11, width: "100%" }}>
                  <thead style={{ background: "#37474f", color: "white" }}>
                    <tr>
                      <th style={{ width: 100 }}>ID FATTURA</th>
                      <th style={{ width: 100 }}>CONTO (raw)</th>
                      <th style={{ width: 130, textAlign: "right" }}>IMPORTO</th>
                      <th style={{ width: 110 }}>DATA REG.</th>
                      <th style={{ width: 80 }}>PLESSO</th>
                      <th>RIGA ID</th>
                      <th style={{ width: 140, textAlign: "center" }}>AZIONE</th>
                    </tr>
                  </thead>
                  <tbody>
                    {nullRows.length === 0 && <tr><td colSpan={7} style={{ padding: 16, textAlign: "center", color: "#888" }}>Nessun dettaglio disponibile.</td></tr>}
                    {nullRows.map(rw => (
                      <tr key={rw.riga_id} data-testid={`pn-ver-nullrow-${rw.riga_id}`}>
                        <td style={{ fontFamily: "monospace", fontWeight: 700, color: "#1565c0" }}>{rw.id_fattura ?? "—"}</td>
                        <td style={{ fontFamily: "monospace", fontWeight: 700, color: "#bf360c" }}>{rw.conto_raw == null ? "NULL" : String(rw.conto_raw)}</td>
                        <td style={{ textAlign: "right", fontFamily: "monospace", fontWeight: 700 }}>€ {fmt(rw.importo)}</td>
                        <td style={{ fontFamily: "monospace", color: "#555" }}>{rw.data_registrazione || "—"}</td>
                        <td style={{ fontFamily: "monospace", color: "#555" }}>{rw.plesso || "—"}</td>
                        <td style={{ fontFamily: "monospace", fontSize: 9, color: "#888" }}>{rw.riga_id}</td>
                        <td style={{ textAlign: "center" }}>
                          {rw.id_fattura ? (
                            <button onClick={() => apriFattura(rw.id_fattura)}
                              data-testid={`pn-ver-open-null-${rw.id_fattura}`}
                              style={{ padding: "3px 10px", background: "#1565c0", color: "white", border: "none", fontSize: 11, fontWeight: 700, cursor: "pointer" }}>
                              📂 Apri fattura
                            </button>
                          ) : <span style={{ color: "#999", fontSize: 10 }}>Senza fattura</span>}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>
          )}

          {/* FOGLIE NON UTILIZZATE */}
          <div style={{ margin: "0 20px 20px", border: "1px solid #888", background: "white" }}>
            <div onClick={() => setShowFoglieNonUsate(s => !s)}
              style={{ padding: "6px 12px", background: "#37474f", color: "white", fontWeight: 700, fontSize: 13, cursor: "pointer", display: "flex", alignItems: "center", gap: 8 }}>
              <span>{showFoglieNonUsate ? "▼" : "▶"}</span>
              <span>📋 Conti presenti nel piano ma MAI usati ({foglieNon.length})</span>
              <span style={{ flex: 1 }} />
              <span style={{ fontSize: 10, fontWeight: 400, opacity: 0.85 }}>(utile per pulire il piano dei conti)</span>
            </div>
            {showFoglieNonUsate && (
              <table className="sw-table sw-table-compact" style={{ fontSize: 11, width: "100%" }}>
                <thead style={{ background: "#37474f", color: "white" }}>
                  <tr>
                    <th style={{ width: 80 }}>CONTO</th>
                    <th style={{ width: 110 }}>PATH</th>
                    <th>DESCRIZIONE</th>
                  </tr>
                </thead>
                <tbody>
                  {foglieNon.length === 0 && <tr><td colSpan={3} style={{ padding: 20, textAlign: "center", color: "#888" }}>Nessuna foglia inutilizzata.</td></tr>}
                  {foglieNon.map(f => (
                    <tr key={f.id_conto}>
                      <td style={{ fontFamily: "monospace", fontWeight: 700, color: "#0d47a1" }}>[{f.id_conto}]</td>
                      <td style={{ fontFamily: "monospace", color: "#888" }}>{f.conto_path}</td>
                      <td>{f.descrizione}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        </>
      )}

      {/* Picker per riassegnazione */}
      <VocePicker open={pickerFor != null} value={null} onClose={() => setPickerFor(null)}
        onSelect={(v) => riassegna(pickerFor, v.id_conto)} />
    </div>
  );
}
